import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import Moment from "react-moment";
import PleaseWait from "../Reuseable/PleaseWait";
import arrow1 from "../../assets/image 13 (Traced).png";
import VideoFrame from "../Modal/VideoFrame";
import { Modal } from "react-bootstrap";
import { fetchJockeyEntries } from "../../redux/getReducer/getEntriesJockey";
import RaceModal from "../Modal/RaceModal";
import ScrollContainer from "react-indiana-drag-scroll";
import { IoMdPlay } from "react-icons/io";
import { truncateRaceType, toTitleCase } from "../../service/stringUtils";
import { useNavigate } from "react-router-dom";


const JockeyEntries = ({ id }) => {
    const { data: entriesjockey } = useSelector((state) => state.entriesjockey);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    
    const [shows, setShows] = useState(false);
    const [modaldatas, setmodaldatas] = useState();
    const handleCloses = () => setShows(false);
    const handleShows = async (data) => {
        setmodaldatas(data);
        await setShows(true);
    };

    const [showRace, setShowRace] = useState(false);
    const [modaldataRace, setmodaldataRace] = useState();
    const handleCloseRace = () => setShowRace(false);
    const handleShowRace = (id) => {
        if (id) navigate("/race-detail?" + id);
    };

    const handleShowHorse = (id) => {
        if (id) navigate("/horse-detail?" + id);
    };

    const { t } = useTranslation();
    const cookiedata = Cookies.get("i18next");

    useEffect(() => {
        dispatch(fetchJockeyEntries({ id }));
    }, [dispatch, id]);

    const FirstLetter = (data) => data ? data.substring(0, 1) : "";

    function distanceLabel(distance, rank) {
        const DistanceTobeChecked = parseFloat(distance);
        if (DistanceTobeChecked.toFixed(2) > 25) {
            return "Dist";
        } else if (DistanceTobeChecked.toFixed(2) == 0.05 && rank < 80) {
            return "SHd";
        } else if (DistanceTobeChecked.toFixed(2) == 0.10 && rank < 80) {
            return "Hd";
        } else if (DistanceTobeChecked.toFixed(2) == 0.25 && rank < 80) {
            return "Nk";
        } else if (DistanceTobeChecked.toFixed(2) == 0.01 && rank < 80) {
            return "Ns";
        } else if (DistanceTobeChecked.toFixed(2) == 0.00 && rank < 80) {
            if (rank === 1) { return 0; }
            return "Dh";
        } else {
            return distance;
        }
    }

    return (
        <>
            <div className="owner-new-entries-grid-wrapper">
                <ScrollContainer className="owner-new-entries-scroll">
                    <div className="owner-new-entries-grid-table">
                        
                        <div className="owner-new-thead-16">
                            <div>{t("Date")}</div><div>{t("Crs")}</div><div>{t("Horse Name")}</div><div>{t("Dist")}</div><div>{t("RT")}</div><div>{t("Time")}</div><div>{t("Jockey")}</div><div>{t("Wgt")}</div><div>{t("FP")}</div><div>{t("Len")}</div><div>{t("RN")}</div><div>{t("BtBy")}</div><div>{t("Kgs")}</div><div>{t("Draw")}</div><div>{t("OR")}</div><div>{t("Link")}</div>
                        </div>

                        {/* --- NEW UI BODY --- */}
                        <div className="owner-new-entries-tbody">
                            {entriesjockey === undefined ? (
                                <div className="text-center py-4"><PleaseWait /></div>
                            ) : !entriesjockey || entriesjockey.length === 0 ? (
                                <div className="text-center py-4">{t("No Entries Available")}</div>
                            ) : (
                                entriesjockey.map((item, i) => {
                                    const ground = item.RaceResultData?.TrackLengthData?.GroundTypeModelData?.NameEn || item.RacehorsesData?.TrackLengthData?.GroundTypeModelData?.NameEn;
                                    const rowBg = ground === "Turf" ? "#d4edda" : ground === "Dirt" ? "#f2e6d9" : "#f1f5f9";

                                    return (
                                        <div 
                                            key={i} 
                                            className="owner-new-row-16" 
                                            style={{ backgroundColor: rowBg, color: '#343433' }}
                                        >
                                            <div onClick={() => handleShowRace(item.RaceID)} className="owner-new-link-white">
                                                <Moment format="DD/MM/YYYY">{item.RaceResultData?.StartTime}</Moment>
                                            </div>
                                            <div>
                                                {item.RaceResultData?.RaceCourseData ? (cookiedata === "en" ? item.RaceResultData.RaceCourseData.AbbrevEn : item.RaceResultData.RaceCourseData.AbbrevAr) : "-"}({FirstLetter(cookiedata === "en" ? ground : item.RaceResultData?.TrackLengthData?.GroundTypeModelData?.NameAr)})
                                            </div>
                                            <div className="owner-new-link-white" onClick={() => handleShowHorse(item.HorseIDData?._id)}>
                                                {cookiedata === "en" ? toTitleCase(item.HorseIDData?.NameEn || "-") : (item.HorseIDData?.NameAr || "-")}
                                            </div>
                                            <div>{item.RaceResultData?.TrackLengthData?.TrackLength || item.Distance || "-"}</div>
                                            <div className="owner-new-truncate">
                                                {item.RaceResultData?.RaceTypeModelData ? (cookiedata === "en" ? toTitleCase(truncateRaceType(item.RaceResultData.RaceTypeModelData.NameEn)) : item.RaceResultData.RaceTypeModelData.NameAr) : "-"}
                                            </div>
                                            <div>{item.RaceTime || "-"}</div>
                                            <div>-</div>
                                            <div>{item.RaceResultData?.RacehorsesData?.[0]?.JockeyRaceWeight || "-"}</div>
                                            <div>
                                                {item.FinalPositionDataHorse ? (cookiedata === "en" ? toTitleCase(item.FinalPositionDataHorse.NameEn) : item.FinalPositionDataHorse.NameAr) : "-"}
                                            </div>
                                            <div>{distanceLabel(item.Distance, item.FinalPositionDataHorse?.Rank)}</div>
                                            <div>{item.RaceResultData?.Runners || item.Runners || "-"}</div>
                                            <div className="owner-new-truncate owner-new-link-white" onClick={() => handleShowHorse(item.BeatenByData?._id || item.BeatenByData)}>
                                                {item.BeatenByData ? toTitleCase(cookiedata === "en" ? item.BeatenByData?.NameEn : item.BeatenByData?.NameAr) : toTitleCase(cookiedata === "en" ? item.HorseIDData?.HorseBeatenByEnglishName : item.HorseIDData?.HorseBeatenByArabicName)}
                                            </div>
                                            <div>{item.BeatenByData ? item.BeatenByData.WinningHorseJockeyWeight : (item.HorseIDData?.BeatenByJockeyWeight || 0)}</div>
                                            <div>{item.RaceResultData?.Draw || item.HorseNo || "-"}</div>
                                            <div>{item.Rating || "0"}</div>
                                            <div className="owner-new-mini-play" onClick={() => handleShows(item.VideoLink)}><IoMdPlay /></div>
                                        </div>
                                    );
                                })
                            )}
                        </div>
                    </div>
                </ScrollContainer>
            </div>

            {/* Modals preserved */}
            <Modal show={shows} onHide={handleCloses} size="lg" centered><Modal.Body><VideoFrame data={modaldatas} /></Modal.Body></Modal>
        </>
    );
};

export default JockeyEntries;